import Vue from 'vue';
import Vuex from 'vuex';

//load modules
import session from './modules/session';
import calendar from './modules/calendar';
import constants from './modules/constants';
import membershipRegistration from './modules/membershipRegistration';
import registerEvent from './modules/registerEvent';
import membershipCard from './modules/membershipCard';
import places from './modules/googlePlaces';
import ui from './modules/ui';
import waiverDialog from './modules/waiverDialog';
import timerDisabled from './modules/timerDisabled';
import axios from 'axios';

Vue.use(Vuex);

function isValidUrl(url) {
	const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
	return urlRegex.test(url);
}

export default new Vuex.Store({  
	state: {
		env: new Map(),
		vueAppLogoView: '',
		dataStep: null
	},
	getters: {
		env: ( state ) => state.env,
		envPromise (state){
			let env =  new Promise(function(resolve) {
				let intervalId = setInterval(function () {
					const env = state.env;
					if ( env !== undefined ) {
						clearInterval(intervalId);
						resolve(env);
					}
				}, 100);
			});	
			return env;
		},
		vueAppLogo (state) {
			return state.env.get('VUE_APP_LOGO');
		},
		vueAppRoot (state) {
			return state.env.get('VUE_APP_ROOT');
		},
		vueAppBase(state) {
			return state.env.get('VUE_APP_BASE');
		},
		vueTabLogo(state){
			return state.env.get('VUE_APP_TAB_LOGO');
		},
		vueAppLogoView (state) {
			return state.vueAppLogoView;
		}
	},
	mutations: {
		SET_LOCAL_ENV (state, map) {
			state.env = new Map(map);
			state.env.set('VUE_APP_API_LINK', `${state.env.get('VUE_APP_ROOT')}/laravel/public/api/v1`)
			state.env.set('VUE_APP_DEFAULT_REGISTRATION', state.env.get('VUE_APP_DEFAULT_REGISTRATION') == 'TRUE' || state.env.get('VUE_APP_DEFAULT_REGISTRATION') == 'true')
			state.env.set('VUE_APP_TAB_LOGO', state.env.get('VUE_APP_STRAPI') + state.env.get('VUE_APP_TAB_LOGO'));
			let value = (process.env.VUE_APP_DEFAULT_ORGANIZATION || "").toString();
			let valueArray = (value || "").length > 0 ? value.split(',') : [];
			state.env.set('VUE_APP_DEFAULT_ORGANIZATION', valueArray);
		},
		SET_STRAPI_PARAMETER_PARTICIPANTS (state, data) {
			state.env = new Map();
			data.forEach(element => {
				const attributes = element.attributes
				let { Name, Value } = attributes;
				if(Name == 'VUE_APP_DEFAULT_ORGANIZATION') {
					let value = (Value || "").toString();
					let valueArray = (value || "").length > 0 ? value.split(',') : [];
					state.env.set(Name, valueArray);
				} else {
					state.env.set(Name, Value);
				}
			});
			
			if(process.env.VUE_APP_IS_DEV_STATION == '1')
			{	
				//dev station hacks
				state.env.set('VUE_APP_API_LINK', process.env.VUE_APP_API_LINK);
				if(process.env.VUE_APP_USE_ENV == '1') {
					state.env.set('VUE_APP_DEFAULT_PROMOTER', process.env.VUE_APP_DEFAULT_PROMOTER);
				}
				let value = (process.env.VUE_APP_DEFAULT_ORGANIZATION || "").toString();
				let valueArray = (value || "").split(',');
				state.env.set('VUE_APP_DEFAULT_ORGANIZATION', valueArray);
				state.env.set('VUE_APP_DEFAULT_REGISTRATION', process.env.VUE_APP_DEFAULT_REGISTRATION);
				state.env.set('VUE_APP_ROOT', process.env.VUE_APP_ROOT);
			}

			state.env.set('VUE_APP_DEFAULT_REGISTRATION', state.env.get('VUE_APP_DEFAULT_REGISTRATION') == 'TRUE' || state.env.get('VUE_APP_DEFAULT_REGISTRATION') == 'true')
		},
		SET_STRAPI_PARAMETER_IMAGES (state, {data, url}) {
			data.forEach(element => {
				const attributes = element.attributes
				const imgUrl = `${url}${attributes.Image.data.attributes.url}`;

				switch (attributes.Name) {
					case 'VUE_APP_TAB_LOGO':
						state.env.set('VUE_APP_TAB_LOGO', imgUrl);
						break;
				
					default:
						state.env.set(attributes.Name, imgUrl);
						break;
				}
				
			});
		},
		SET_LOGO_VIEW (state, data) {
			state.vueAppLogoView = data;
		},
		SET_DATA_STEP (state, data) {
			state.dataStep = data;
		}
	},
	actions: {
		setLogo({ commit, getters }) {
			const url = getters['vueAppLogo'];
			if((url || "").length > 0 && !url.includes('@/assets/') && isValidUrl(url)) {
				axios.get(url).then(() => {
					commit("SET_LOGO_VIEW",url);
				}).catch(() => {
					commit("SET_LOGO_VIEW",require(process.env.VUE_APP_LOGO));
				});
			} else {
				commit("SET_LOGO_VIEW",require(process.env.VUE_APP_LOGO));
			}
		},
		async setEnv({commit,dispatch}){
			
			const env = process.env
			const map = new Map(Object.entries(env));

			if(map.get('VUE_APP_USE_ENV') == '1'){
				/** 
				 * Get the enviroment variables from the .env file 
				 * */
				commit("SET_LOCAL_ENV", map)
				dispatch("setLogo");
				return;
			}

			/** 
			 * Get the enviroment variables from strapi 
			 * */
			const {protocol, host, hostname} = window.location
			let url = '';
			const hostElements = host.split('.');

			if(hostname == 'localhost' || map.get('VUE_APP_IS_DEV_STATION') == '1')
			{
				url = process.env.VUE_APP_STRAPI
			}
			else
			{
				if (hostElements.length == 2) {
					url = `${protocol}//strapi.${host}`;
				}else{
					url = `${protocol}//${hostElements[0]}.strapi.${hostElements[1]}.${hostElements[2]}`;
				}
			}
			
			try {
				const parameterParticipants = await axios.get(`${url}/api/parameter-participants?pagination[pageSize]=1000`);
				commit("SET_STRAPI_PARAMETER_PARTICIPANTS", parameterParticipants.data.data)
				
				try {
					const parameterImages = await axios.get(`${url}/api/parameter-images?populate=*`);					
					commit("SET_STRAPI_PARAMETER_IMAGES", {data: parameterImages.data.data, url})
				} catch {/*---*/}
				dispatch("setLogo");
			}
			catch {/**---*/}
		}
	},
	modules: { 
		session,
		constants,
		ui,
		calendar,
		membershipRegistration,
		registerEvent,
		membershipCard,
		places,
		waiverDialog,
		timerDisabled
	},
});

//export default { Store };
 